import { render } from "./FooterContent.vue?vue&type=template&id=61c907c4&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=61c907c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c907c4"]])

export default __exports__